var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("page-header", {
        attrs: {
          actions: _vm.headerActionConfig,
          "left-side-class": "col-xl-6 pb-2",
          page: _vm.headerConfig,
          "right-side-class":
            "col-xl-6 align-items-end d-flex pb-4 justify-content-end"
        }
      }),
      _c("section-title", {
        attrs: { content: "Información General", "has-line": "" }
      }),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-md-4" }, [
          _c("div", { staticClass: "color-secondary-6 font-14" }, [
            _vm._v(" Año Académico: ")
          ]),
          _c("div", { staticClass: "color-black font-16" }, [
            _vm._v(" " + _vm._s(_vm.detail.academicYear) + " ")
          ])
        ]),
        _c("div", { staticClass: "col-md-4" }, [
          _c("div", { staticClass: "color-secondary-6 font-14" }, [
            _vm._v(" Área: ")
          ]),
          _c("div", { staticClass: "color-black font-16" }, [
            _vm._v(" " + _vm._s(_vm.detail.area) + " ")
          ])
        ]),
        _c("div", { staticClass: "col-md-4" }, [
          _c("div", { staticClass: "color-secondary-6 font-14 mr-4" }, [
            _vm._v(" Tipo de Proveedor: ")
          ]),
          _c("div", { staticClass: "color-black font-16" }, [
            _vm._v(" " + _vm._s(_vm.detail.recruitmentName) + " ")
          ])
        ])
      ]),
      _c("section-title", {
        staticClass: "mt-3",
        attrs: { content: "Listado de Documentos", "has-line": "" }
      }),
      _c(
        "div",
        { staticClass: "d-flex justify-content-end mb-3" },
        [
          _vm.canEditDocuments && !this.addingDocument
            ? _c("action-button", {
                staticClass: "mr-2",
                class: _vm.isDragAndDropEnable
                  ? "custom-reorganize-btn text-white"
                  : "outline-dark-gray",
                attrs: {
                  i: "far fa-sort-numeric-up",
                  text: _vm.isDragAndDropEnable
                    ? "Finalizar Reorganización"
                    : "Reorganizar Documentos"
                },
                on: {
                  click: function($event) {
                    return _vm.reorganize()
                  }
                }
              })
            : _vm._e(),
          _vm.canEditDocuments &&
          !this.addingDocument &&
          !this.isDragAndDropEnable
            ? _c("action-button", {
                attrs: {
                  i: "fas fa-file-plus",
                  text: "Añadir Documento",
                  variant: "success"
                },
                on: { click: () => (this.addingDocument = true) }
              })
            : _vm._e()
        ],
        1
      ),
      _vm.addingDocument
        ? _c("add-document", {
            staticClass: "mb-3",
            attrs: { "document-types": _vm.documentTypes },
            on: {
              "on-cancel": () => (this.addingDocument = false),
              "on-create": function($event) {
                return _vm.onAddDocumentHandler($event)
              }
            }
          })
        : _vm._e(),
      _c(
        "draggable",
        {
          attrs: {
            disabled: !_vm.isDragAndDropEnable,
            "force-fallback": "",
            "ghost-class": "ghost"
          },
          model: {
            value: _vm.detail.documents,
            callback: function($$v) {
              _vm.$set(_vm.detail, "documents", $$v)
            },
            expression: "detail.documents"
          }
        },
        _vm._l(_vm.detail.documents, function(item) {
          return _c("document-row", {
            key: item.proposalDocumentTypeId,
            attrs: {
              "draggable-enabled": _vm.isDragAndDropEnable,
              value: item
            },
            on: {
              "on-delete": function($event) {
                return _vm.onDeleteDocumentHandler($event)
              },
              "on-update": function($event) {
                return _vm.onUpdateDocumentHandler($event)
              }
            }
          })
        }),
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }